import { cn } from '../lib/utils';
import { FormControl, FormDescription, FormField, FormItem, FormMessage, useFormContext } from './form';
import { MultiSelect, MultiSelectContent, MultiSelectGroup, MultiSelectItem, MultiSelectTrigger, MultiSelectValue } from './multi-select';

interface FormControlProps {
  name: string;
  label?: string;
  description?: string;
  className?:string;
}

export const MultiSelectField = ({
  name,
  className,
  label,
  description,
  listOption
}: FormControlProps & {
  listOption: {
    label: string;
    value: string;
  }[];
}) => {
  const { control } = useFormContext();
  return (
    <>
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <MultiSelect onValuesChange={field.onChange} values={field.value}>
                <MultiSelectTrigger
                  className={cn("bg-white w-full", className)}
                >
                  <div className="flex flex-col max-w-full text-left">
                    <div className="text-xs font-normal text-gray-500 group-disabled/trigger:text-om-ink-300s">
                      {label}
                    </div>
                    <MultiSelectValue
                      className="text-base text-left"
                      placeholder="Chọn giá trị"
                      overflowBehavior="cutoff"
                    />
                  </div>
                </MultiSelectTrigger>

                <MultiSelectContent>
                  <MultiSelectGroup>
                    {listOption.map(({ label, value }) => (
                      <MultiSelectItem value={value} key={value}>
                        {label}
                      </MultiSelectItem>
                    ))}
                  </MultiSelectGroup>
                </MultiSelectContent>
              </MultiSelect>
            </FormControl>

            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
